<template>
  <b-modal
    visible
    hide-header-close
    no-close-on-backdrop
    size="sm"
    @hide="$emit('close')"
    body-class="p-4"
    footer-class="d-flex justify-content-end px-4 py-3 border-top"
    header-class="d-flex align-items-center justify-content-between px-4 py-3 border-bottom"
  >
    <template #modal-header>
      <h6 class="font-weight-bold text-dark mb-0">Withdraw to M-Pesa</h6>
      <button
        @click="$emit('close')"
        class="btn btn-light btn-sm border-0 d-flex align-items-center justify-content-center p-1"
        style="width:30px;height:30px;border-radius:6px;"
      >
        <i class="fas fa-times text-secondary"></i>
      </button>
    </template>

    <div v-if="!success">
      <p class="text-secondary mb-3" style="font-size:13px;">
        Available balance: <strong class="text-dark">{{ formattedBalance }}</strong>
      </p>

      <div class="form-group mb-3">
        <label class="font-weight-bold text-secondary mb-1 d-block" style="font-size:12px;letter-spacing:0.4px;text-transform:uppercase;">
          M-Pesa number
        </label>
        <vue-tel-input placeholder="712345678" v-model="form.phone"></vue-tel-input>
      </div>

      <div class="form-group mb-3">
        <label class="font-weight-bold text-secondary mb-1 d-block" style="font-size:12px;letter-spacing:0.4px;text-transform:uppercase;">
          Amount
        </label>
        <input type="number" class="form-control form-control-sm" placeholder="Enter amount" v-model="form.amount">
      </div>

      <div class="form-group mb-1">
        <label class="font-weight-bold text-secondary mb-1 d-block" style="font-size:12px;letter-spacing:0.4px;text-transform:uppercase;">
          Reason
        </label>
        <textarea class="form-control form-control-sm" v-model="form.reason"></textarea>
      </div>

      <div
        v-if="error"
        class="d-flex align-items-center p-3 bg-light border mt-3"
        style="border-radius:6px;gap:8px;"
      >
        <i class="fas fa-exclamation-circle text-secondary"></i>
        <span class="text-dark" style="font-size:13px;">{{ error }}</span>
      </div>
    </div>

    <div v-else class="text-center py-3">
      <i class="fas fa-check-circle text-dark mb-2" style="font-size:32px;"></i>
      <p class="text-dark mb-0" style="font-size:13px;">{{ success }}</p>
    </div>

    <template #modal-footer>
      <template v-if="!success">
        <button @click="$emit('close')" class="btn btn-light btn-sm border font-weight-600 mr-2">
          Cancel
        </button>
        <button
          @click="submit"
          :disabled="loading || !form.amount || !form.phone"
          class="btn btn-dark btn-sm d-inline-flex align-items-center"
          style="gap:6px;"
        >
          <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          {{ loading ? 'Submitting...' : 'Withdraw' }}
        </button>
      </template>
      <button v-else @click="$emit('close')" class="btn btn-dark btn-sm">Done</button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  name: 'WithdrawModal',

  props: {
    balance: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      form: {
        amount: '',
        phone: '',
        reason: ''
      },
      loading: false,
      error: null,
      success: null
    };
  },

  computed: {
    formattedBalance() {
      return 'KES ' + this.balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  },

  methods: {
    async submit() {
      this.loading = true;
      this.error = null;

      try {
        const res = await axios.post('/api/dukakit-account/withdraw', { ...this.form });

        if (res.status === 200 && res.data.type === 'success') {
          this.success = 'Your request has been received and is being processed. You will receive a notification.';
          this.$emit('withdrawn');
        } else {
          this.error = res.data.message || 'Failed to submit withdrawal request';
        }
      } catch (err) {
        this.error = err.response?.data?.message || 'Failed to submit withdrawal request';
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
